import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './components/app.component';
import { unauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  { path: '', component: AppComponent, pathMatch: 'full', canActivate: [MsalGuard] },
  { path: 'orders', loadChildren: () => import('./feature-modules/orders/orders.module').then(m => m.OrdersModule), canActivate: [MsalGuard] },
  {path: 'unauthorized', component: unauthorizedComponent }
];

@NgModule({
  //imports: [RouterModule.forRoot(routes, {useHash: true, scrollPositionRestoration:'enabled'})],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
